var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('notifications',{staticClass:"error-handler",attrs:{"group":"error-handler","position":"bottom center","width":"100%"},scopedSlots:_vm._u([{key:"body",fn:function(ref){
var item = ref.item;
var close = ref.close;
return [_c('ErrorHandlerItem',{attrs:{"item":item},on:{"close":close}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }